//@flow

export const getItem = <T>(key: string): ?T => {
    return JSON.parse(window.localStorage.getItem(key));
};

export const setItem = <T>(key: string, object: T): void => {
    window.localStorage.setItem(key, JSON.stringify(object));
};
